import React, { useEffect, useState } from "react";
import {
  AssessmentActivities,
  ExpertiseType,
  SubjectModel,
  TeachingActivity,
} from "../../../domain/SubjectModel";
import { EvaluateAssessmentExperienceForm } from "./AssessmentExperience/EvaluateAssessmentExperienceForm";
import { EvaluateTeachingExperienceForm } from "./TeachingExperience/EvaluateTeachingExperienceForm";
import { EvaluateIndustryExperienceForm } from "./IndustryExperience/EvaluateIndustryExperienceForm";
import { Evaluation } from "../../../domain/ApprovalSubject";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tab: {
    overflow: 'scroll',
    height: '100%',
    marginBottom: '85px',
  },
}));


export interface EvaluateExperienceProps {
  subjects: SubjectModel[];
  evaluations: Evaluation | null;
}

export const EvaluateExperience: React.FC<EvaluateExperienceProps> = ({
  subjects,
  evaluations,
}) => {
  const [hasAssessmentSubjects, setHasAssessmentSubjects] = useState(false);
  const [hasTeachingSubjects, setHasTeachingSubjects] = useState(false);
  const [hasIndustrySubjects, setHasIndustrySubjects] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!!subjects) {
      setHasAssessmentSubjects(subjects.some(
        (s) => s.selectedAssessmentActivities !== AssessmentActivities.None
      ));
      setHasTeachingSubjects(subjects.some(
        (s) => s.teachingActivity !== TeachingActivity.None
      ));
      setHasIndustrySubjects(subjects.some(
        (s) => s.expertiseType & ExpertiseType.Industry
      ));
    }
  }, [subjects, setHasAssessmentSubjects, setHasTeachingSubjects, setHasIndustrySubjects]);

  return (
    <>
      <div className={classes.tab}>
        {hasAssessmentSubjects && (
          <EvaluateAssessmentExperienceForm
            subjects={subjects}
            evaluations={evaluations}
          />
        )}
        {hasIndustrySubjects && (
          <EvaluateIndustryExperienceForm
            subjects={subjects}
            evaluations={evaluations}
          />
        )}
        {hasTeachingSubjects && (
          <EvaluateTeachingExperienceForm
            subjects={subjects}
            evaluations={evaluations}
          />
        )}
      </div>
    </>
  );
};
